import { Typography, Box } from '@material-ui/core'

import LimitationImage from 'assets/images/trial-start.png'

import { DialogBody } from './DialogBody'

const blue = 'rgba(38, 198, 218, 0.9)'
const yellow = 'rgba(255, 202, 40, 0.9)'

type Props = {
    trialDays: number
    onClose: () => void
}

export const TrialPlanStartedDialog = ({ onClose, trialDays }: Props) => {
    const messagePart = trialDays ? `${trialDays} days` : ''

    return (
        <DialogBody
            isOpen
            onClose={onClose}
            image={LimitationImage}
            bubblesBackground={[blue, yellow]}
            onPrimaryClick={onClose}
            primaryButtonMt={3}
            imageMt={3}
            primaryText="Continue"
            title="Woo-Hoo! Your trial has started"
            maxTextWidth="350px"
            text={
                <Box mt={3}>
                    <Typography>
                        During your {messagePart} trial, you will have access to unlimited
                        step-by-step videos with custom branding, blur of sensitive information, and
                        activity feed
                    </Typography>
                </Box>
            }
        />
    )
}
